import { IFontFamily } from '../types';

export const fontFamily: IFontFamily = {
  primary: '"chicken_sans_bold", sans-serif',
  secondary: '"Helvetica Neue", Helvetica, Arial, sans-serif',
};
